import React from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../components/ui/accordion";
import Seo from "../components/site/Seo";
import { Container, Eyebrow, CtaBand } from "../components/site/Ui";
import { GENERAL_FAQ } from "../data/site";
import { useLang } from "../lib/LangContext";


export default function Faq() {
  const { tr } = useLang();
  return (
    <>
      <Seo
        title="FAQ — frequently asked questions about PostMint"
        description="Answers about how PostMint works, revisions, languages, publishing, uploads, VAT and delivery timelines for our social media content service."
        path="/faq"
      />

      <section className="mesh-warm" data-testid="faq-hero">
        <Container className="py-16 lg:py-20">
          <Eyebrow>{tr("FAQ")}</Eyebrow>
          <h1 className="mt-5 max-w-3xl text-4xl font-extrabold leading-tight text-slate-900 sm:text-5xl lg:text-6xl">
            {tr("Frequently asked questions.")}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">
            {tr("Still unsure about something? Send us a message and we'll answer directly.")}
          </p>
        </Container>
      </section>

      <section className="py-16">
        <Container>
          <div className="rounded-3xl border border-slate-200 bg-white px-6 soft-shadow sm:px-8">
            <Accordion type="single" collapsible className="divide-y divide-slate-200">
              {GENERAL_FAQ.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} className="border-0">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-5 text-left font-display text-base font-semibold text-slate-900 hover:no-underline"
                  >
                    {tr(f.q)}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">{tr(f.a)}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Container>
      </section>

      <CtaBand testId="faq-final-cta-button" />
    </>
  );
}
